import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import CommandPalette from '@/components/CommandPalette'
import CioDock from '@/components/cio/CioDock'
import { useCioDock } from '@/components/cio/useCioDock'

export default function AppLayout() {
  const dock = useCioDock()
  const { pathname } = useLocation()
  // The dock hides itself on its own page, so the layout must not reserve room for it
  // there either, or the page would sit against an empty gutter.
  const reserve = dock.open && !pathname.startsWith('/ai-cio')

  return (
    <div className="flex h-screen bg-background">
      <CommandPalette />
      <Sidebar />
      <div
        className="flex flex-1 flex-col overflow-hidden transition-[margin] duration-150"
        style={{ marginRight: reserve ? dock.width : 0 }}>
        <Header />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
      {/* Mounted at the layout so the pane survives navigation: the point of docking the
          AI CIO is to ask about the page you are on without losing it. */}
      <CioDock open={dock.open} setOpen={dock.setOpen} width={dock.width}
               startDrag={dock.startDrag} />
    </div>
  )
}
